// extracted by mini-css-extract-plugin
export default {"root":"_Jds7srY","drawerContent":"okJfwei2","chartContainer":"viuasOUc","winPercentage":"OukfLF0B","stat":"yaZdCGTx","win":"RLZ5RrPJ","loss":"hNMuL07W"};